__turbopack_context__.v({
  "calendar": "qA-Doq_calendar",
  "day": "qA-Doq_day",
  "dayNumber": "qA-Doq_dayNumber",
  "grid": "qA-Doq_grid",
  "header": "qA-Doq_header",
  "heading": "qA-Doq_heading",
  "highlight": "qA-Doq_highlight",
  "highlightFill": "qA-Doq_highlightFill",
  "monthBody": "qA-Doq_monthBody",
  "monthViewport": "qA-Doq_monthViewport",
  "navButton": "qA-Doq_navButton",
  "navigation": "qA-Doq_navigation",
  "outside": "qA-Doq_outside",
  "placeholderDay": "qA-Doq_placeholderDay",
  "selected": "qA-Doq_selected",
  "srOnly": "qA-Doq_srOnly",
  "title": "qA-Doq_title",
  "titleRow": "qA-Doq_titleRow",
  "today": "qA-Doq_today",
  "todayButton": "qA-Doq_todayButton",
  "week": "qA-Doq_week",
  "weekdays": "qA-Doq_weekdays",
});
